<!-- filepath: /Users/nicdev/Hoverlay/Dev/spaces.hoverlay.com/src/views/hoverlay/pages/sequencing/components/ActionMenu.vue -->
<template>
  <div class="card after-previous rounded-sm">
    <div class="vx-full m-2"><span>Add ACTION: </span></div>
    <vs-collapse accordion type="border">
      <!-- Show/Hide Actions -->
      <vs-collapse-item>
        <div slot="header" class="cursor-pointer">
          <div class="vs-list--title">
            <i class="vs-icon notranslate icon-scale feather icon-sunrise null"></i>
            Show/Hide
          </div>
        </div>
        <vs-list>
          <div @click="selectAction('action_show')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_show']" title="Show" subtitle="Make objects appear"></vs-list-item>
          </div>
          <div @click="selectAction('action_hide')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_hide']" title="Hide" subtitle="Make objects disappear"></vs-list-item>
          </div>
          <div @click="selectAction('action_toggle_show_hide')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_toggle_show_hide']" title="Show/Hide" subtitle="Toggle visibility"></vs-list-item>
          </div>
        </vs-list>
      </vs-collapse-item>

      <!-- Audio/Video Actions -->
      <vs-collapse-item>
        <div slot="header" class="cursor-pointer">
          <div class="vs-list--title">
            <i class="vs-icon notranslate icon-scale feather icon-headphones"></i>
            Audio/Video
          </div>
        </div>
        <vs-list>
          <div @click="selectAction('action_play')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_play']" title="Play" subtitle="Play"></vs-list-item>
          </div>
          <div @click="selectAction('action_pause')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_pause']" title="Pause" subtitle="Pause"></vs-list-item>
          </div>
          <div @click="selectAction('action_stop')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_stop']" title="Stop" subtitle="Stop"></vs-list-item>
          </div>
          <div @click="selectAction('action_toggle_play_pause')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_toggle_play_pause']" title="Toggle Play/Pause" subtitle="Toggle between play and pause"></vs-list-item>
          </div>
          <div @click="selectAction('action_seek')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_seek']" title="Set Start Time" subtitle="Seeks a specific start time"></vs-list-item>
          </div>
          <div @click="selectAction('action_end')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_end']" title="Force to end" subtitle="Jump to end of playable"></vs-list-item>
          </div>
        </vs-list>
      </vs-collapse-item>

      <!-- Animation Actions -->
      <vs-collapse-item>
        <div slot="header" class="cursor-pointer">
          <div class="vs-list--title">
            <i class="vs-icon notranslate icon-scale feather icon-triangle"></i>
            Animation
          </div>
        </div>
        <vs-list>
          <div @click="selectAction('action_spin')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_spin']" title="Spin" subtitle="Spins object"></vs-list-item>
          </div>
          <div @click="selectAction('action_orbit')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_orbit']" title="Orbit" subtitle="Orbits object around another"></vs-list-item>
          </div>
          <div @click="selectAction('action_move_in_direction')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_move_in_direction']" title="Move in direction" subtitle="Moves object in a specific direction"></vs-list-item>
          </div>
          <div @click="selectAction('action_transform_by')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_transform_by']" title="Transform by" subtitle="Transform object by an offset"></vs-list-item>
          </div>
          <div @click="selectAction('action_transform_to')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_transform_to']" title="Transform to" subtitle="Transform object to a fixed pos, rot and scale"></vs-list-item>
          </div>
          <div @click="selectAction('action_animate')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_animate']" title="Play animation" subtitle="Play animation clip on 3D object"></vs-list-item>
          </div>
          <div @click="selectAction('action_play_particles')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_play_particles']" title="Play Particles" subtitle="Plays particles (Unity object only)"></vs-list-item>
          </div>
        </vs-list>
      </vs-collapse-item>

      <!-- UX Actions -->
      <vs-collapse-item>
        <div slot="header" class="cursor-pointer">
          <div class="vs-list--title">
            <i class="vs-icon notranslate icon-scale feather icon-user"></i>
            UX
          </div>
        </div>
        <vs-list>
          <div @click="selectAction('action_change_space')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_change_space']" title="Change space" subtitle="load a different space"></vs-list-item>
          </div>
          <div @click="selectAction('action_history_back')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_history_back']" title="Previous space" subtitle="Go back one space"></vs-list-item>
          </div>
          <div @click="selectAction('action_open_url')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_open_url']" title="Open URL" subtitle="Display a web page"></vs-list-item>
          </div>
          <div @click="selectAction('action_show_instructions')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_show_instructions']" title="Show Instructions" subtitle="Display on-screen instructions"></vs-list-item>
          </div>
          <div v-if="layerHomePageType == 'map'" @click="selectAction('action_open_home')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_open_home']" title="Open Home" subtitle="Open the home page"></vs-list-item>
          </div>
        </vs-list>
      </vs-collapse-item>

      <!-- Trigger Actions -->
      <vs-collapse-item>
        <div slot="header" class="cursor-pointer">
          <div class="vs-list--title">
            <i class="vs-icon notranslate icon-scale feather icon-user"></i>
            Triggers
          </div>
        </div>
        <vs-list>
          <div @click="selectAction('trigger_image_anchor_found')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['trigger_image_anchor_found']" title="Wait for Image Found" subtitle="Wait for user to point phone at image"></vs-list-item>
          </div>
          <div @click="selectAction('trigger_tap')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['trigger_tap']" title="Wait for Tap" subtitle="Wait for user to tap on an object"></vs-list-item>
          </div>
          <div @click="selectAction('trigger_screen_tap')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['trigger_screen_tap']" title="Wait for Screen Tap" subtitle="Wait for user to tap anywhere on the screen"></vs-list-item>
          </div>
        </vs-list>
      </vs-collapse-item>

      <!-- Others Actions -->
      <vs-collapse-item>
        <div slot="header" class="cursor-pointer">
          <div class="vs-list--title">
            <i class="vs-icon notranslate icon-scale feather icon-more-horizontal"></i>
            Others
          </div>
        </div>
        <vs-list>
          <div @click="selectAction('action_raise_event')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_raise_event']" title="Raise event" subtitle="Use to notify other sequences"></vs-list-item>
          </div>
          <div @click="selectAction('action_set_experience_origin')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_set_experience_origin']" title="Set user origin" subtitle="Sets the starting location for unfolding content attached to user"></vs-list-item>
          </div>
          <div v-if="userRole == 'admin'" @click="selectAction('action_force_end_sequence')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_force_end_sequence']" title="End sequence" subtitle="Force a sequence to complete"></vs-list-item>
          </div>
          <div @click="selectAction('action_set_materials_variant')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_set_materials_variant']" title="Sets material variant" subtitle="Sets sepecific material variant on GLB (GLB with material variants only)"></vs-list-item>
          </div>
          <div @click="selectAction('action_start_following')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_start_following']" title="Start following screen" subtitle="Attach object(s) to screen"></vs-list-item>
          </div>
          <div @click="selectAction('action_stop_following')" class="cursor-pointer">
            <vs-list-item :icon="iconActionDic['action_stop_following']" title="End following screen" subtitle="Detach object(s) from screen"></vs-list-item>
          </div>
        </vs-list>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
// Import constants from the constants folder
import { SEQUENCE_ELEMENT_ICONS } from '../constants/sequence-element-icons'

export default {
  name: 'ActionMenu',
  props: {
    // You can pass customized icons if needed
    icons: {
      type: Object,
      default: () => SEQUENCE_ELEMENT_ICONS
    },
    // You can pass user role to control visibility of certain actions
    userRole: {
      type: String,
      default: 'user'
    },
    // You can pass the type of home page for the channel, which control visibility
    layerHomePageType: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      iconActionDic: this.icons || SEQUENCE_ELEMENT_ICONS
    }
  },
  methods: {
    selectAction(actionType) {
      // Emit the selected action type to the parent component
      this.$emit('action-selected', actionType)
    }
  }
}
</script>

<style scoped lang="scss">
.after-previous {
  margin-top: 28px;
}

.after-previous::before {
  content: "";
  position: absolute;
  top: -18px;
  left: 50%;
  transform: translateX(-50%);
  width: 0px;
  height: 0px;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-top: 14px solid #6262626e;
}

.card {
  position: relative;
  margin-left: 0px;
  padding: 0 20px 0 20px;
  background: linear-gradient(90deg, rgba(248, 248, 248, 0.778), 0%, #fff 300%);
  border-radius: 10px;
  border: 1px solid rgb(255, 255, 255);
  max-width: 400px;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 4px 0px
}
</style>